import type { FantasyGameId } from '~/types/fantasy'
import csLogo from './assets/cs-logo.png'
import csLogo2x from './assets/cs-logo@2x.png'
import dotaLogo from './assets/dota-logo.png'
import dotaLogo2x from './assets/dota-logo@2x.png'

type GameIconAssets = {
  logo: string
  logo2x: string
}

export const gameIcons = {
  cs: {
    logo: csLogo,
    logo2x: csLogo2x
  },
  dota: {
    logo: dotaLogo,
    logo2x: dotaLogo2x
  }
} satisfies Record<FantasyGameId, GameIconAssets>
